import { render, staticRenderFns } from "./CustomizationTags.vue?vue&type=template&id=5aad879a&lang=pug"
import script from "./CustomizationTags.vue?vue&type=script&lang=js"
export * from "./CustomizationTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports